// Leeftijden die in het CMS nog niet kloppen.
const corrections = {
  chantal: 21,
  rutger: 40,
};

const correctAge = (name, age) => {
  const key = String(name || '').trim().split(' ')[0].toLowerCase();
  return corrections[key] !== undefined ? corrections[key] : age;
};

// Voor namen met de leeftijd erin, zoals "Rutger Tideman (39 jaar)".
export const correctNameAge = (name) => String(name || '').replace(
  /\((\d+) jaar\)/,
  (match, age) => `(${correctAge(name, age)} jaar)`,
);

export default correctAge;
